import apiClient from 'utilities/apiClient';

// Public — no auth header, so it also works on the login page.
export const status = () => {
  return apiClient.get(`${apiClient.Urls.maintenance}/status`, {}, false);
};

export const maintenance = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.maintenance}/${url}`, payload, true);
};

export const updatemaintenance = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.maintenance}/${url}`, payload, true);
};
